import { gql } from "@apollo/client"

export interface UpdateOrganizationInput {
  id: number
  address1: string
  address2?: string
  country: string
  city: string
  vat?: string
  clientMutationId?: string
}

export const UPDATE_ORG_ADDRESS = gql`
  mutation updateMyOrgAddress($input: UpdateOrganizationInput!) {
    updateOrganization(input: $input) {
      organization {
        id
        name
      }
      errors {
        field
        messages
      }
    }
  }
`
